module.exports = __webpack_public_path__ + "static/img/13.e895c22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zongce/13.jpg
// module id = DAMN
// module chunks = 1